import { useNavigate } from "react-router-dom";
import { formatearMoneda } from "../../funcionesDatos/Moneda";

const ESTADO_DESEMBOLSO = {
    pendiente:   { label: "Pendiente",   cls: "bg-warning-subtle text-warning-emphasis border border-warning-subtle" },
    programado:  { label: "Programado",  cls: "bg-primary-subtle text-primary-emphasis border border-primary-subtle" },
    pagado:      { label: "Pagado",      cls: "bg-success-subtle text-success-emphasis border border-success-subtle" },
    retenido:    { label: "Retenido",    cls: "bg-danger-subtle text-danger-emphasis border border-danger-subtle" },
    fallido:     { label: "Fallido",     cls: "bg-danger-subtle text-danger-emphasis border border-danger-subtle" },
    cancelado:   { label: "Cancelado",   cls: "bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle" },
};

function fmt(n) { return formatearMoneda(Number(n || 0), "COP"); }

function fmtFecha(f) {
    if (!f) return "—";
    return new Date(f).toLocaleString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

function AvatarUser({ u, rol }) {
    if (!u) return <span className="text-muted small">—</span>;
    const nombre = [u.nombre, u.apellido].filter(Boolean).join(" ") || u.username || "—";
    return (
        <div className="d-flex align-items-center gap-2">
            <img src={u.avatar || "/imagenes/marca/avatar.png"} alt={u.username} className="rounded-circle flex-shrink-0" style={{ width: 28, height: 28, objectFit: "cover" }} />
            <div style={{ lineHeight: 1.2 }}>
                <div className="small fw-semibold text-dark text-truncate" style={{ maxWidth: 120 }}>{nombre}</div>
                <div className="text-muted" style={{ fontSize: "0.7rem" }}>@{u.username || "—"}</div>
            </div>
        </div>
    );
}

function ListaPagos({ pagos = [], total = 0, pagina = 1, paginas = 1, onPagina }) {
    const navigate = useNavigate();

    const inicio = (pagina - 1) * 20;
    const fin = inicio + pagos.length;

    return (
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="fw-bold mb-1">Pagos recibidos</h5>
                    <p className="text-secondary mb-0 small">Reservas con pago aprobado por el comprador.</p>
                </div>
                <span className="badge rounded-pill bg-light text-dark border px-3 py-2">{total} pagos</span>
            </div>

            <div className="card-body p-0">
                {pagos.length === 0 ? (
                    <div className="p-5 text-center text-muted">
                        <i className="bi bi-credit-card fs-2 d-block mb-2" style={{ opacity: 0.3 }}></i>
                        <span className="small">No hay pagos para mostrar con los filtros actuales.</span>
                    </div>
                ) : (
                    <>
                        {/* Tabla escritorio */}
                        <div className="d-none d-lg-block overflow-x-auto">
                            <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.85rem" }}>
                                <thead className="table-light">
                                    <tr>
                                        <th className="ps-4 fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Fecha pago</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Servicio</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Comprador</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Vendedor</th>
                                        <th className="text-end fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Total</th>
                                        <th className="text-end fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Comisión</th>
                                        <th className="text-end fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Vendedor recibe</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Desembolso</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagos.map((p) => {
                                        const est = ESTADO_DESEMBOLSO[p.desembolso?.estado] || ESTADO_DESEMBOLSO.pendiente;
                                        const montoUrgencia = Number(p.cobro?.montoUrgencia || 0);
                                        const esUrgente = p.cobro?.esUrgente && montoUrgencia > 0;
                                        const totalVendedor = Number(p.desembolso?.montoProveedor || 0) + (esUrgente ? montoUrgencia : 0);
                                        return (
                                            <tr key={p._id} style={{ cursor: "pointer" }} onClick={() => navigate("/admin/pago", { state: { params: { idReserva: p._id } } })}>
                                                <td className="ps-4 text-muted" style={{ whiteSpace: "nowrap", fontSize: "0.82rem" }}>{fmtFecha(p.cobro?.fechaPago || p.createdAt)}</td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-1 flex-wrap">
                                                        <span className="fw-semibold text-dark text-truncate" style={{ maxWidth: 160, fontSize: "0.85rem" }}>{p.nombreServicio || "—"}</span>
                                                        {esUrgente && (
                                                            <span className="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle" style={{ fontSize: "0.62rem", padding: "1px 6px" }}>
                                                                <i className="bi bi-lightning-fill"></i> Urgente
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="text-muted" style={{ fontSize: "0.72rem" }}>{p.tipoPaquete || "—"}</div>
                                                </td>
                                                <td><AvatarUser u={p.comprador} /></td>
                                                <td><AvatarUser u={p.proveedor} /></td>
                                                <td className="text-end fw-bold text-dark" style={{ fontSize: "0.85rem" }}>{fmt(p.cobro?.montoTotal)}</td>
                                                <td className="text-end text-muted" style={{ fontSize: "0.85rem" }}>{fmt(p.comision?.monto)}</td>
                                                <td className="text-end fw-semibold text-success" style={{ fontSize: "0.85rem" }}>
                                                    {fmt(totalVendedor)}
                                                    {esUrgente && <div className="text-muted fw-normal" style={{ fontSize: "0.68rem" }}>base {fmt(p.desembolso?.montoProveedor)} +{fmt(montoUrgencia)}</div>}
                                                </td>
                                                <td><span className={`badge rounded-pill px-2 py-1 ${est.cls}`} style={{ fontSize: "0.7rem" }}>{est.label}</span></td>
                                                <td><i className="bi bi-chevron-right text-muted" style={{ fontSize: "0.75rem" }}></i></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Lista móvil */}
                        <div className="d-lg-none list-group list-group-flush">
                            {pagos.map((p) => {
                                const est = ESTADO_DESEMBOLSO[p.desembolso?.estado] || ESTADO_DESEMBOLSO.pendiente;
                                const montoUrgencia = Number(p.cobro?.montoUrgencia || 0);
                                const esUrgente = p.cobro?.esUrgente && montoUrgencia > 0;
                                const totalVendedor = Number(p.desembolso?.montoProveedor || 0) + (esUrgente ? montoUrgencia : 0);
                                return (
                                    <div
                                        key={p._id}
                                        className="list-group-item p-3"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/admin/pago", { state: { params: { idReserva: p._id } } })}
                                    >
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div className="d-flex align-items-center gap-1 flex-wrap">
                                                <div className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>{p.nombreServicio || "—"}</div>
                                                {esUrgente && (
                                                    <span className="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle" style={{ fontSize: "0.62rem", padding: "1px 6px" }}>
                                                        <i className="bi bi-lightning-fill"></i> Urgente
                                                    </span>
                                                )}
                                            </div>
                                            <span className={`badge rounded-pill px-2 py-1 ms-2 flex-shrink-0 ${est.cls}`} style={{ fontSize: "0.7rem" }}>{est.label}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <AvatarUser u={p.comprador} />
                                            <div className="text-end">
                                                <div className="fw-bold text-dark">{fmt(p.cobro?.montoTotal)}</div>
                                                <div className="text-success small">{fmt(totalVendedor)} vendedor</div>
                                                {esUrgente && <div className="text-muted" style={{ fontSize: "0.68rem" }}>base {fmt(p.desembolso?.montoProveedor)} +{fmt(montoUrgencia)}</div>}
                                            </div>
                                        </div>
                                        <div className="text-muted mt-1" style={{ fontSize: "0.72rem" }}>{fmtFecha(p.cobro?.fechaPago || p.createdAt)}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>

            <div className="card-footer bg-white border-0 p-3 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3">
                <small className="text-secondary">
                    {pagos.length > 0 ? `${inicio + 1}–${fin} de ${total}` : "Sin resultados"}
                </small>
                <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-light border rounded-pill px-3 btn-sm" disabled={pagina <= 1} onClick={() => onPagina(pagina - 1)}>Anterior</button>
                    <span className="small text-secondary">Pág. {pagina} de {paginas}</span>
                    <button className="btn btn-light border rounded-pill px-3 btn-sm" disabled={pagina >= paginas} onClick={() => onPagina(pagina + 1)}>Siguiente</button>
                </div>
            </div>
        </div>
    );
}

export default ListaPagos;
